var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { type: "primary" } },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.toQuery }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.toAddAirPortRequirement }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NewTo")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.toUpdateAirPortRequirement }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_EditTo")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "danger" },
                  on: { click: _vm.toBatchDelAirPortRequirement }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
              ),
              _c("cargo-grid-state-btn", {
                attrs: {
                  "grid-params": _vm.gridParams,
                  "config-module": "101340"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "100px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.LoadingPort") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              "callback-method-type": "value",
                              "default-value":
                                _vm.searchConditions.loadingPortCode,
                              "callback-params": { key: "loadingPortCode" }
                            },
                            on: { parentCallBack: _vm.getValueSearchFromChild }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfDestination")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              "callback-method-type": "value",
                              "default-value":
                                _vm.searchConditions.dischargingPortCode,
                              "callback-params": { key: "dischargingPortCode" }
                            },
                            on: { parentCallBack: _vm.getValueSearchFromChild }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CargoType,
                              "callback-method-type": "value",
                              "default-value": _vm.searchConditions.cargoType,
                              "callback-params": { key: "cargoType" }
                            },
                            on: { parentCallBack: _vm.getValueSearchFromChild }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "100px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.AirlineCompany") }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { airCmp: true },
                              "callback-method-type": "value",
                              "default-value":
                                _vm.searchConditions.carrierId == 0
                                  ? ""
                                  : _vm.searchConditions.carrierId,
                              "callback-params": { key: "carrierId" }
                            },
                            on: { parentCallBack: _vm.getValueSearchFromChild }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.DestinationAgent") }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "callback-method-type": "value",
                              "default-value":
                                _vm.searchConditions.destinationAgent == 0
                                  ? ""
                                  : _vm.searchConditions.destinationAgent,
                              "method-params": { overseaAgent: true },
                              "callback-params": { key: "destinationAgent" }
                            },
                            on: { parentCallBack: _vm.getValueSearchFromChild }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "101340",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchConditions.total > 0,
                    expression: "searchConditions.total>0"
                  }
                ],
                attrs: {
                  "config-module": "19198",
                  total: _vm.searchConditions.total,
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.fetchAirPortRequirement
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm.isShowingAirportRequirementForm
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                "custom-class": "",
                visible: _vm.isShowingAirportRequirementForm,
                title: _vm.formTitle,
                width: "1000px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.isShowingAirportRequirementForm = $event
                },
                close: _vm.cancel
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "padding-bottom": "10px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        model: _vm.airPortRequirement,
                        inline: "",
                        "label-width": "110px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_DisplayRules")
                              }
                            },
                            [
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    model: {
                                      value: _vm.airPortRequirement.mawb,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.airPortRequirement,
                                          "mawb",
                                          $$v
                                        )
                                      },
                                      expression: "airPortRequirement.mawb"
                                    }
                                  },
                                  [_vm._v("MAWB")]
                                ),
                                _c(
                                  "el-checkbox",
                                  {
                                    model: {
                                      value: _vm.airPortRequirement.hawb,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.airPortRequirement,
                                          "hawb",
                                          $$v
                                        )
                                      },
                                      expression: "airPortRequirement.hawb"
                                    }
                                  },
                                  [_vm._v("HAWB")]
                                )
                              ]
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-form-item-wrapper",
                          staticStyle: { "padding-top": "10px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.LoadingPort") }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Airport,
                                  "callback-method-type": "value",
                                  "default-multiple-value":
                                    _vm.airPortRequirement.loadingPortCodeArray,
                                  "callback-params": {},
                                  multiple: ""
                                },
                                on: {
                                  parentCallBack: function(item) {
                                    return (_vm.airPortRequirement.loadingPortCodeArray =
                                      item.value)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.PortOfDestination")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Airport,
                                  "callback-method-type": "value",
                                  "default-multiple-value":
                                    _vm.airPortRequirement
                                      .dischargingPortCodeArray,
                                  "callback-params": {},
                                  multiple: ""
                                },
                                on: {
                                  parentCallBack: function(item) {
                                    return (_vm.airPortRequirement.dischargingPortCodeArray =
                                      item.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-form-item-wrapper",
                          staticStyle: { "padding-top": "10px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.PlaceOfDelivery")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Airport,
                                  "callback-method-type": "value",
                                  "default-multiple-value":
                                    _vm.airPortRequirement
                                      .destinationPortCodeArray,
                                  "callback-params": {},
                                  multiple: ""
                                },
                                on: {
                                  parentCallBack: function(item) {
                                    return (_vm.airPortRequirement.destinationPortCodeArray =
                                      item.value)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Airline") } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Region,
                                  "default-multiple-value":
                                    _vm.airPortRequirement.regionCodeArray,
                                  "callback-params": {},
                                  multiple: ""
                                },
                                on: {
                                  parentCallBack: function(item) {
                                    return (_vm.airPortRequirement.regionCodeArray =
                                      item.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-form-item-wrapper",
                          staticStyle: { "padding-top": "10px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.AirlineCompany")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { airCmp: true },
                                  "callback-method-type": "value",
                                  "default-value":
                                    _vm.airPortRequirement.carrierId == 0
                                      ? ""
                                      : _vm.airPortRequirement.carrierId,
                                  "callback-params": { key: "carrierId" }
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.DestinationAgent")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                key: 1,
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "callback-method-type": "value",
                                  "default-value":
                                    _vm.airPortRequirement.destinationAgent == 0
                                      ? ""
                                      : _vm.airPortRequirement.destinationAgent,
                                  "method-params": { overseaAgent: true },
                                  "callback-params": { key: "destinationAgent" }
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-form-item-wrapper",
                          staticStyle: { "padding-top": "10px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CargoType,
                                  "callback-method-type": "value",
                                  "default-value":
                                    _vm.airPortRequirement.cargoType,
                                  "callback-params": { key: "cargoType" }
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-form-item-wrapper",
                          staticStyle: { "padding-top": "10px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.OperationRequirements")
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "730px" },
                                attrs: {
                                  type: "textarea",
                                  rows: 5,
                                  placeholder: _vm.$t(
                                    "Message.PleaseEnterTheContent"
                                  )
                                },
                                model: {
                                  value:
                                    _vm.airPortRequirement
                                      .operationRequirements,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.airPortRequirement,
                                      "operationRequirements",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "airPortRequirement.operationRequirements"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showCloudFile,
                              expression: "showCloudFile"
                            }
                          ],
                          staticClass: "el-form-item-wrapper",
                          staticStyle: { "padding-top": "10px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("queryJob.AttachmentDescription")
                              }
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "yibiao-tijiao" },
                                on: { click: _vm.appendixDescription }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.submitAirPortRequirement }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.isShowingAirportRequirementForm = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          lob: _vm.cloudFile.lob,
          "show-all": _vm.cloudFile.showAll
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: _vm.onUploadDone
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }